<script setup>

const props = defineProps({
  attrs: {
    type: Object,
  },
	id: {
		type: Number
	}
})

</script>

<template>
	<NuxtLinkLocale
		class="cover relative overflow-hidden aspect-square text-light p-8 flex items-end text-[32px] tracking-[-0.48px] fvs600"
		:to="{ name: 'album-slug-audio', params: { slug: attrs.album.id, audio: id } }"
	>
		<NuxtImg preload class="absolute top-0 left-0 min-w-full min-h-full max-h-full max-w-full object-cover" :src="attrs.album.attrs.image?.url" />
		<span class="back z-30 bg-dark8 flex items-start p-8">
			<span>
				<h4 class="line-clamp-1 text-gold">{{ attrs.album.attrs.artistdisplay }}</h4>
				<h4 class="line-clamp-1 text-gold mb-[8cqw]">{{ attrs.title }}</h4>
				<h4 class="line-clamp-[7] dark:text-light" v-html="attrs.album.attrs.annotation" />
			</span>
		</span>
	</NuxtLinkLocale>
</template>

<style lang="scss" scoped>

	.cover {
		container-type: size;
		&:hover {
			.back {
				opacity: 1;
    		top: 0;
			}
		}
	}

	h4 {
		font-size: 7.5cqw;
		word-break: break-word;
	}

	.back {
		position: absolute;
		left: 0;
		right: 0;
		height: 100%;
		background-color: theme('colors.dark8');
		top: 100%;
		transition: .3s cubic-bezier(0.390, 0.575, 0.565, 1.000);
	}

</style>